import React, { useEffect } from 'react';
import { Chip } from '@mui/material';
import PinDrop from '@mui/icons-material/PinDrop';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Offsite = (props) => {
   const openDrawer = () => {
      props.setStatusDrawerOpen(true);
      props.setSpaceData(props.data);
   };

   if (props.miniChips) {
      return (
         <Chip
            size="small"
            sx={props.styles}
            variant="outlined"
            clickable={props.clickable}
            label={<PinDrop />}
            color={props.bookings ? 'primary' : 'default'}
         />
      );
   }
   {
      if (props.clickable) {
         return (
            <Chip
               size="medium"
               sx={{
                  '& .MuiChip-label': {
                     pl: 1,
                  },
               }}
               clickable={props.clickable}
               label={<PinDrop sx={{ mt: 0.5 }} />}
               color={props.bookings ? 'primary' : 'default'}
               deleteIcon={<MoreVertIcon />}
               variant="outlined"
               onDelete={() => openDrawer()}
            />
         );
      } else {
         return (
            <Chip
               size="medium"
               clickable={props.clickable}
               label={<PinDrop sx={{ mt: 0.5 }} />}
               color="primary"
               variant="outlined"
            />
         );
      }
   }
};
export default Offsite;
